import type { AnySchema } from 'yup'
import { ValidationError } from 'yup'

export const validateApiResponse = <T>(schema: AnySchema, data: unknown): T => {
  try {
    return schema.validateSync(data, { strict: false }) as T
  } catch (error) {
    const message = error instanceof ValidationError ? error.message : String(error)
    console.warn('[API response validation]', message)
    return data as T
  }
}
